//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import IsapreTypeList from '@/views/HumanResource/HrIsapreType/IsapreTypeList'

//
export default {
    path: 'isapre',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'isapres-list',
            component: IsapreTypeList,
        },
    ],
    meta: {
        title: 'Isapres',
    },
}
